import React from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";

function Dance() {
  return (
    <Template>
      <BreadCrumb pageName="Dance" />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div className="col-12 pbmit-footer-right">
              <h2
                style={{
                  textAlign: "center",
                  marginBottom: "30px",
                  color: "#05AAE3",
                }}
              >
                DANCE YOUR WAY TO FITNESS
              </h2>
            </div>

            <div className="col-xl-5 col-lg-12">
              <img
                src="https://images.healthshots.com/healthshots/en/uploads/2025/01/14152526/dance-exercise-final.jpg"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt="Dance Workout"
              />
            </div>

            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                    }}
                  >
                    WHAT YOU’LL EXPERIENCE
                  </span>
                </div>

                <p>
                  Our dance fitness sessions combine high energy music, fun
                  choreography, and effective workouts to help you burn
                  calories, boost stamina, and improve coordination.
                </p>

                <p>
                  Whether you're a beginner or a dance lover, our sessions are
                  designed to keep you moving, smiling, and feeling confident.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                    }}
                  >
                    PROGRAM HIGHLIGHTS
                  </span>
                </div>

                <p>
                  <b>ENERGETIC DANCE WORKOUTS – 3–5 SESSIONS PER WEEK</b>
                </p>

                <ul className="list-group list-group-borderless" style={{marginBottom: 0}}>
                  <li className="list-group-item">
                    High-energy dance routines for fat burn & endurance
                  </li>
                  <li className="list-group-item">
                    Bollywood, Zumba, Hip-Hop & Freestyle styles
                  </li>
                  <li className="list-group-item">
                    Recorded sessions available for flexible timing
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-5 col-lg-12">
              <img
                src="https://media.gettyimages.com/id/1388558904/video/multiracial-people-dancing-in-fitness-dance-studio.jpg?s=640x640&k=20&c=rCG8FgRu7pBPu9IDPzFTjAn_1beQV7IKtfDOcG8QAEM="
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt="Dance Workout Session"
              />
            </div>
          </div>
        </div>
      </section>
      <hr />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div className="col-xl-5 col-lg-12">
              <img
                src="https://cdn.shopify.com/s/files/1/0430/6533/files/OzQvwVeWEiOYq8VxemYHLNGyA2Sx3OJ91614347671.jpg?v=1614787195"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt="Dance Equipment"
              />
            </div>

            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                    }}
                  >
                    WHAT YOU NEED
                  </span>
                </div>

                <ul className="list-group list-group-borderless" style={{marginBottom: 0}}>
                  <li className="list-group-item">
                    Comfortable dance shoes or sneakers
                  </li>
                  <li className="list-group-item">Lightweight activewear</li>
                  <li className="list-group-item">Water bottle & towel</li>
                  <li className="list-group-item">
                    Positive energy & enthusiasm
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Template>
  );
}

export default Dance;
